'use client';

import { useEffect } from 'react';

export const useStripToken = () => {
  useEffect(() => {
    // Check if we're on the client-side
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href).toString();
      if (url.includes('#')) {
        const [stripped] = url.split('#');
        window.history.replaceState({}, '', stripped);
      }
    }
  }, []);

  return null;
};
